import {Component, OnInit, Input, NO_ERRORS_SCHEMA, NgModule, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Customer} from '../customer';
import {CustomerService} from '../customer.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {CityService} from "../../../../services/city.service";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {ParentShowComponent} from "../../../../components/parent-show";
import {ItemsGroupsShowComponent} from "../../itemsGroups/itemsGroups-show/itemsGroups-show.component";
import {CitiesShowComponent} from "../../cities/cities-show/cities-show.component";
import {YearsShowComponent} from "../../years/years-show/years-show.component";
import {MyInputsModule} from '../../../../my-inputs/my-inputs.module';



@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule,MessagesModule,MyInputsModule,
        ReactiveFormsModule, ConfirmDialogModule,TranslateModule.forChild()
    ],
    declarations: [
        CustomersShowComponent
    ],
    entryComponents: [
        CustomersShowComponent
    ],
    exports: [],
    providers: [SharedService, CustomerService, CityService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-customers-show',
    templateUrl: './customers-show.component.html',
    styleUrls: ['./customers-show.component.scss'],
    providers: [CustomerService, CityService, ConfirmationService, MessageService]
})

export class CustomersShowComponent implements OnInit, AfterViewInit {
    id: string;
    customer = new Customer();
    applog: AppLogComponent;
    @Input() refShow;
    parent:any;
    modalRef: NgbModalRef;


    cities: any[] = [];
    @Input() delId;
    @Input() scrId;
    @Input() oldData;
    @Input() newData;
    @Input() newDatap;
    @Input() modelName;
    statusVal = [{'val': 1, 'title': 'Active'}, {'val': 2, 'title': 'Inactive'}];
    cuntryTypeVal = [{'val': 1, 'title': 'sweetened '}, {'val': 2, 'title': 'international'}];
    tax_calssVal = [{'val':1,'title':'intax'},{'val':2,'title':'outtax'}];

    form: FormGroup;
    private sub: any;
    msgs: Message[] = [];

    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private cityService: CityService,
                private modalService: NgbModal,
                private customerService: CustomerService,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setItemShow(CustomersShowComponent);
        this.sharedservice.setButtons([
            { label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton' },
            { label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton' },
            // { label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton' },
            { label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton' },
            { label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton' },
        ]);
        this.sharedservice.setModelName('customers');

    }
ngAfterViewInit(){
  if(!this.scrId && !this.oldData) {
    this._editButton = document.getElementById('editButton');
    this._deleteButton = document.getElementById('deleteButton');
    this._newButton = document.getElementById('newButton');
    this._printButton = document.getElementById('printButton');
    this._searchButton = document.getElementById('searchButton');

    if (this._editButton) {
      this._editButton.onclick = ((e: any) => {
        e.preventDefault();
        this.router.navigate(['/customers/edit', this.id]);
      });
    }
    if (this._deleteButton) {
      this._deleteButton.onclick = ((e: any) => {
        e.preventDefault();
        this.deleteCustomer(this.customer);
      });
    }
    if (this._newButton) {
      this._newButton.onclick = ((e: any) => {
        e.preventDefault();
        this.router.navigate(['/customers']);
      });
    }
    if (this._searchButton) {
      this._searchButton.onclick = ((e: any) => {
        e.preventDefault();
        this.router.navigate(['/customers/search']);
      });

    }
  }

}
    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.customer;
        modalRef.componentInstance.rowId = '';

    }
    showParent(){
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                console.log("before dismiss");
                //
                return true;
            }
        };
        this.modalRef = this.modalService.open(CitiesShowComponent, options);
        this.modalRef.componentInstance.scrId = this.parent;

        this.modalRef.result.then(() => {
            this.activeModal.dismiss('done');
        }, () => {
            console.log('Backdrop click')
        });
    }
    ngOnInit() {
        this.cityService.getAllCities().subscribe(
            cities => {
                this.cities = cities;
            });
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}),
            name: new FormControl({value: '', disabled: true}),
            max_debit: new FormControl({value: '', disabled: true}),
            city_id: new FormControl({value: '', disabled: true}),
            address: new FormControl({value: '', disabled: true}),
            manager_name: new FormControl({value: '', disabled: true}),
            account_no: new FormControl({value: '', disabled: true}),
            mobile: new FormControl({value: '', disabled: true}),
            telephone: new FormControl({value: '', disabled: true}),
            fax: new FormControl({value: '', disabled: true}),
            email: new FormControl({value: '', disabled: true}),
            status: new FormControl({value: '', disabled: true}),
            type_country: new FormControl({value: '', disabled: true}),
            tax_number: new FormControl({value: '', disabled: true}),
        });

        if (this.id) {
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;
            this.newDatap = true;

            this.delId = false;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];
            }
            this.customerService.getById(this.id).subscribe(
                customer => {
                    this.id = customer.id;
                    this.customer = customer;
                    this.parent = customer.city_id;
                    this.form.patchValue({
                        id: customer.id,
                        name: customer.name,
                        max_debit: customer.max_debit,
                        city_id: customer.city_id,
                        address: customer.address,
                        manager_name: customer.manager_name,
                        account_no: customer.account_no,
                        mobile: customer.mobile,
                        telephone: customer.telephone,
                        fax: customer.fax,
                        email: customer.email,
                        status: customer.status,
                        type_country: customer.type_country,
                        tax_number: customer.tax_number,
                    });
                }, error => {
                    console.log(error);
                }
            );

        }
      if (this.scrId) {
        this.oldData = false;
        this.newData = false;
        this.delId = false;
            this.customerService.getById(this.scrId).subscribe(
                customer => {
                    this.id = customer.id;
                    this.customer = customer;
                    this.parent = customer.city_id;
                    this.form.patchValue({
                        id: customer.id,
                        name: customer.name,
                        max_debit: customer.max_debit,
                        city_id: customer.city_id,
                        address: customer.address,
                        manager_name: customer.manager_name,
                        account_no: customer.account_no,
                        mobile: customer.mobile,
                        telephone: customer.telephone,
                        fax: customer.fax,
                        email: customer.email,
                        status: customer.status,
                        type_country: customer.type_country,
                        tax_number: customer.tax_number,
                    });
                }, error => {
                    console.log(error);
                }
            );

        }
        if (this.delId) {
            this.oldData = false;
            this.newData = false;
            this.newDatap = !this.newDatap ;
            this.customerService.getTrashedById(this.delId).subscribe(
                customer => {
                    this.id = customer.id;
                    this.customer = customer;
                    this.form.patchValue({
                        id: customer.id,
                        name: customer.name,
                        max_debit: customer.max_debit,
                        city_id: customer.city_id,
                        address: customer.address,
                        manager_name: customer.manager_name,
                        account_no: customer.account_no,
                        mobile: customer.mobile,
                        telephone: customer.telephone,
                        fax: customer.fax,
                        email: customer.email,
                        status: customer.status,
                        type_country: customer.type_country,
                        tax_number: customer.tax_number,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
            this.customer = this.newData;

            this.form.patchValue({
                id: this.newData.id,
                name: this.newData.name,
                max_debit: this.newData.max_debit,
                city_id: this.newData.city_id,
                address: this.newData.address,
                status: this.newData.status,
                type_country: this.newData.type_country,
                manager_name: this.newData.manager_name,
                account_no: this.newData.account_no,
                mobile: this.newData.mobile,
                telephone: this.newData.telephone,
                fax: this.newData.fax,
                email: this.newData.email,
                tax_number: this.newData.tax_number,
            });
        }
    }
    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if(userRoles.indexOf('setting.customers.'+role) >= 0) {
            return true;
        }
        return false;
    }

    deleteCustomer(customer: Customer) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (customer) {
                    this.customerService.delete(customer.id).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Delete completed')
                            });
                            setTimeout(()=> {
                                this.router.navigate(['/customers']);
                              },1000);
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                            window.scroll(0,0);
                            }
                    );
                }
            }
        });
    }

    recoverEdit(customer: Customer) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (customer) {
                    this.customerService.update(customer).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/customers/show', customer.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.customerService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/customers/list']);
                        }
                    );
                }
            }
        });
    }


  showattachement(row_id: string) {
    console.log(row_id)
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }
  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
      modalRef.componentInstance.rowId = row_id;
        modalRef.componentInstance.refShow = CustomersShowComponent;

    }
  }


}



// WEBPACK FOOTER //
// ./src/app/views/setting/customers/customers-show/customers-show.component.ts